export default __webpack_public_path__ + "static/jonathan-marbutt-de75ed9723e3c4033faec3036f601f34.png";